
export const AHOC_UPLOAD_DOCUMENTS =
  "allsureHomeClaim/uploadDocuments/";

export const AHOC_UPLOAD_DOCUMENTS_SET_VALUE =
AHOC_UPLOAD_DOCUMENTS+"setValue/";
export const AHOC_UPLOAD_DOCUMENTS_SET_VALID =
AHOC_UPLOAD_DOCUMENTS +"setValid/";



export const setAhocDocumentValue =(value)=>({type: AHOC_UPLOAD_DOCUMENTS_SET_VALUE, value})
export const setAhocDocumentValid =(error,fileType)=>({type: AHOC_UPLOAD_DOCUMENTS_SET_VALID, error, fileType})


export const AHOC_UPLOAD_DOCUMENTS_ADDITIONAL_DOCUMENT =
AHOC_UPLOAD_DOCUMENTS +"addAdditionalDocument";
export const addAdditionalDocuments =()=>({type: AHOC_UPLOAD_DOCUMENTS_ADDITIONAL_DOCUMENT})

export const AHOC_UPLOAD_DOCUMENTS_ADD_TECHNICAL_REPORT = AHOC_UPLOAD_DOCUMENTS +"technicalReport";
export const addTechnicalReport =()=>({type: AHOC_UPLOAD_DOCUMENTS_ADD_TECHNICAL_REPORT})

export const AHOC_UPLOAD_DOCUMENTS_ADD_FIRE_REPORT = AHOC_UPLOAD_DOCUMENTS +"fireReport";
export const addFireReport =()=>({type: AHOC_UPLOAD_DOCUMENTS_ADD_FIRE_REPORT})

export const AHOC_UPLOAD_DOCUMENTS_RESET =
AHOC_UPLOAD_DOCUMENTS +"reset";
export const resetAhocDocuments =()=>({type: AHOC_UPLOAD_DOCUMENTS_RESET})

const SIZE_2_MB = 2097152;
const SIZE_1_kb = 1024;


export const AHOC_UPLOAD_DOCUMENTS_CONFIG = {

  MIN_INPUT_SIZE: SIZE_1_kb,
  MIN_INPUT_SIZE_NAME: '1 kb',
  MAX_INPUT_SIZE: SIZE_2_MB,
  MAX_INPUT_SIZE_NAME: '2 mb',
  VALID_UPLOAD_TYPES: [
      { FORMAT: 'image/jpeg', FORMAT_NAME: 'JPG' },
      {FORMAT: 'image/png', FORMAT_NAME: 'PNG'},
      { FORMAT: 'application/pdf', FORMAT_NAME: 'PDF' },
  ],
};

export const AHOC_UPLOAD_DOCUMENTS_SET_PRESIGNED_VALUE =
AHOC_UPLOAD_DOCUMENTS+"/setPresignedValue";

export const updateAhocPresignedUrl =(value)=>({type: AHOC_UPLOAD_DOCUMENTS_SET_PRESIGNED_VALUE, value})